import dialogRefStore from './dialogRefStore';

export const isDialogOpenSelector = (state) => state.dialog.open;

export const dialogPropsSelector = () => dialogRefStore.props;

export const dialogComponentSelector = () => dialogRefStore.Component;
